import React from "react";

const ButtonTertiary = ({cta, color}) => {
  return (
<button
  type="button"
  aria-label="contacter"
  className={`inline-block bg-transparent border border-current rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200 ${color?color:'violet'}`}>
  {cta}
</button>
  )
}

export default ButtonTertiary
